import axios from "axios";
import { apiUrl } from "features/configure";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import useWindowWidth from "hooks/useWindowWidth";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useOutletContext } from "react-router";

export default function useGetKnowledgeBase() {
  const { formatMessage } = useIntl();
  const [entityName] = useOutletContext();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const windowWidth = useWindowWidth();
  const tableWidth = windowWidth - 780 - 64;
  const headCells = [
    {
      show: true,
      disabledSort: true,
      id: "name",
      width: tableWidth / 4,
      label: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          Name
        </div>
      ),
      title: "Name",
    },
    {
      show: true,
      disabledSort: true,
      id: "type",
      width: tableWidth / 4,
      label: (
        <div style={{ display: "flex", flexDirection: "column" }}>Type</div>
      ),
      title: "Type",
    },
    {
      show: true,
      disabledSort: true,
      id: "createdAt",
      width: tableWidth / 4,
      label: (
        <div style={{ display: "flex", flexDirection: "column" }}>
          Created At
        </div>
      ),
      title: "Created At",
    },
    {
      show: true,
      disabledSort: true,
      id: "status",
      width: tableWidth / 4,
      label: (
        <div style={{ display: "flex", flexDirection: "column" }}>Status</div>
      ),
      title: "Status",
    },
    {
      show: true,
      disabledSort: true,
      id: "action",
      maxWidth: "64",
      width: "64",
      label: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {formatMessage({ id: "campaigns.header.action" })}
        </div>
      ),
      title: "Action",
    },
  ];
  const dispatchSnackbar = useDispatchSnackbar();

  async function handleRefresh() {
    try {
      setIsLoading(true);
      const { data } = await axios.post(
        `${apiUrl}/api/knowledgeBase/${entityName}/refresh`
      );
      setData(data?.resources);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchData() {
    try {
      setIsLoading(true);
      const { data } = await axios(`${apiUrl}/api/knowledgeBase/${entityName}`);
      setData(data?.resources);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  return {
    headCells,
    data,
    fetchData,
    handleRefresh,
    isLoading,
    cellWidth: tableWidth / 4,
  };
}
